import { computed } from '@vue/composition-api'
import isEmpty from 'lodash/isEmpty'

import store from '@/store'
import { logoAirlineUrl } from '@/@core/utils/utils'
import VueI18n from '@/libs/i18n'
import env from '@/libs/env'
// ANCHOR General
export const genderOptions = computed(() => store.getters['globalConfig/getConfig']('gender')?.map(item => ({
  value: item.key,
  label: item.value,
  text: item.value,
})))
// return [
//   { label: 'Male', text: 'Male', value: 'MALE' },
//   { label: 'Female', text: 'Female', value: 'FEMALE' },
//   { label: 'Other', text: 'Other', value: 'OTHER' },
// ]

export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

export const genderOptionsToString = (space = ',') => genderOptions.value.map(item => item.text).join(space) // Male,Female,Other

export function resolveGender(gender, from = 'label', to = 'value') {
  if (!gender || isEmpty(genderOptions.value)) return undefined
  return genderOptions.value.find(
    item => item[from].toLowerCase() === gender?.toLowerCase(),
  )[to]
}

// export const sizePerPageOptions = [10, 20, 30, 40]
export const sizePerPageOptions = computed(() => store.getters['globalConfig/getConfig']('sizePerPage')?.map(item => parseInt(item.value, 10)))

// large sizePerPage = [10,20,40,60,80,100]
export const sizePerPageLgOptions = [10, 20, 40, 60, 80, 100]

export const airlineOptions = [ // source options
  { label: 'Bamboo Airways (QH)', text: 'Bamboo Airways (QH)', value: 'QH' },
  { label: 'Vietnam Airlines (VN)', text: 'Vietnam Airlines (VN)', value: 'VN' },
  { label: 'Vietjet Air (VJ)', text: 'Vietjet Air (VJ)', value: 'VJ' },
  { label: 'Vietravel Airlines (VU)', text: 'Vietravel Airlines (VU)', value: 'VU' },
  { label: 'Travelport (1G)', text: 'Travelport (1G)', value: '1G' },
]

export const hotAirlineOptions = [
  { label: 'Bamboo Airways (QH)', text: 'Bamboo Airways (QH)', value: 'QH' },
  { label: 'Vietnam Airlines (VN)', text: 'Vietnam Airlines (VN)', value: 'VN' },
  { label: 'Vietjet Air (VJ)', text: 'Vietjet Air (VJ)', value: 'VJ' },
  { label: 'Vietravel Airlines (VU)', text: 'Vietravel Airlines (VU)', value: 'VU' },
]

export const distributorOptions = [
  { label: 'Vietnam Airlines (1S)', value: '1S', image: logoAirlineUrl('1S') },
  { label: 'Vietnam Airlines (VN1A)', value: 'VN1A', image: logoAirlineUrl('VN') },
  { label: 'Vietjet Air (VJ)', value: 'VJ', image: logoAirlineUrl('VJ') },
  { label: 'Vietravel Airlines (VU)', value: 'VU', image: logoAirlineUrl('VU') },
  { label: 'Bamboo Airways (QH)', value: 'QH', image: logoAirlineUrl('QH') },
  { label: 'Travelport (1G)', value: '1G', image: logoAirlineUrl('1G') },
  { label: 'AirAsia (AK)', value: 'AK', image: logoAirlineUrl('AK') },
]

export const distributorsList = computed(() => store.getters['globalConfig/getAllAvailableDistributors'])
export const distributorsListWithTrain = computed(() => {
  const airlineDistributors = store.getters['globalConfig/getAllAvailableDistributors']
  const trainDistributor = 'TRAIN'
  const tourDistributor = 'TOUR'

  const sources = [...airlineDistributors]

  if (!env.isHideTrain) {
    sources.push(trainDistributor)
  }
  if (!env.isHideTour) {
    sources.push(tourDistributor)
  }

  return sources
})

export const saleReportTicketTypeOptions = [
  { label: 'saleReport.TOPUP', value: 'TOPUP' },
  { label: 'saleReport.SPENDING_NOTE', value: 'SPENDING_NOTE' },
  { label: 'saleReport.RECEIPTS_NOTE', value: 'RECEIPTS_NOTE' },
  { label: 'saleReport.TKT', value: 'TKT' },
  { label: 'saleReport.EMD', value: 'EMD' },
  { label: 'saleReport.RFD', value: 'RFD' },
  { label: 'saleReport.VOID', value: 'VOID' },
  { label: 'saleReport.INSURANCE', value: 'INSURANCE' },
  { label: 'saleReport.PACKAGE_ORDER', value: 'PKG' },
  { label: 'saleReport.TOUR_REFUND', value: 'TOUR_REFUND' },
  { label: 'saleReport.TOUR_DEPOSIT', value: 'TOUR_DEPOSIT' },
  { label: 'saleReport.TOUR_PAYMENT', value: 'TOUR_PAYMENT' },
]

export const distributorExtendOptions = [
  // { label: 'Vietnam Airlines (1S)', value: '1S' },
  // { label: 'VNA Sabre Miền Trung (1S_CTRL)', value: '1S_CTRL' },
  { label: 'Vietnam Airlines (VN1A)', value: 'VN1A' },
  { label: 'Vietnam Airlines Miền Trung (VN1A_MT)', value: 'VN1A_MT' },
  { label: 'Vietjet Air (VJ)', value: 'VJ' },
  { label: 'Vietravel Airlines (VU)', value: 'VU' },
  { label: 'Bamboo Airways (QH)', value: 'QH' },
  { label: 'Travelport (1G)', value: '1G' },
  { label: 'AirAsia (AK)', value: 'AK' },
  { label: 'Other (OF)', value: 'F1' },
  { label: 'Scoot (TR)', value: 'TH' },
]

export const ticketTypeOptions = [
  { label: 'Nội địa', value: 'INLAND' },
  { label: 'Quốc tế', value: 'INTERNATIONAL' },
]

export const typeOfDateFilterOptions = [
  { label: 'applyDate', value: 'applyDate' },
  { label: 'flightDate', value: 'flightDate' },
]

export const airlineFilterOptions = [
  { label: 'QH', value: 'QH' },
  { label: 'VN', value: 'VN' },
  { label: 'VJ', value: 'VJ' },
  { label: 'VU', value: 'VU' },
  { label: '1G', value: '1G' },
  { label: 'AK', value: 'AK' },
]

export const typeOfDiscountOptions = [
  { label: 'VND', value: 'VND' },
  { label: '%', value: '%' },
]

export const typeOfDiscountPaidOptions = [
  { label: 'PREPAID', value: 'PREPAID' },
  { label: 'POSTPAID', value: 'POSTPAID' },
]

export const typeOfDiscountStrategyOptions = [
  // { label: 'BY_TICKET_NUMBER', value: 'BY_TICKET_NUMBER' },
  { label: 'BY_CUSTOMER_SEGMENT', value: 'BY_CUSTOMER_SEGMENT' },
]

export const flightTypeOptions = [
  { label: 'saleReport.domesticAndInbound', value: 'INLAND_AND_INTERNATIONAL' },
  { label: 'saleReport.domestic', value: 'INLAND' },
  { label: 'saleReport.inbound', value: 'INTERNATIONAL' },
  { label: 'saleReport.bookGroup', value: 'BOOK_GROUP' },
]

export const flightTypeOptionsForPromotionAg = [
  { label: 'saleReport.domesticAndInbound', value: null },
  { label: 'saleReport.domestic', value: 'INLAND' },
  { label: 'saleReport.inbound', value: 'INTERNATIONAL' },
]

// for promotion AG
export const bookerTypeOptions = [
  { label: 'saleReport.domestic', value: 'DOMESTIC' },
  { label: 'saleReport.inbound', value: 'INTERNATIONAL' },
]

// ANCHOR Employee
export const typeOfEmployeeOptions = computed(() => store.getters['globalConfig/getConfig']('employeeType')?.map(item => ({
  value: item.key,
  label: item.value,
  text: item.value,
})))
// [
//   { label: 'Admin', text: 'Admin', value: 'ADM' },
//   { label: 'operatingSystem', text: 'OPE', value: 'OPE' },
//   { label: 'chiefAccountant', text: 'Chief Accountant', value: 'KTT' },
//   { label: 'Accountant', text: 'Accountant', value: 'KTV' },
//   { label: 'Saler', text: 'Saler', value: 'SE' },
//   { label: 'Booker', text: 'Booker', value: 'BE' },
// ]

export const typeOfEmployeeOptionsKhacADM = computed(() => {
  if (!typeOfEmployeeOptions.value) return []
  return typeOfEmployeeOptions.value.filter(item => !['ADM', 'OPE', 'KTT'].includes(item.value))
})
export const typeOfEmployeeOptionsFilter = computed(
  () => typeOfEmployeeOptions.value,
)

export const typeOfEmployeeOptionsFilterToString = (space = ',') => typeOfEmployeeOptionsFilter.value?.map(item => item.text).join(space) // OPE, Chief Accountant, Accountant, Booker, Saler

export function resolveEmployeeType(type, from = 'label', to = 'value') {
  if (!typeOfEmployeeOptions.value || !type) return null
  const typeEmployee = typeOfEmployeeOptions.value.find(
    item => item[from].toLowerCase() === type.toLowerCase(),
  )?.[to]
  const result = typeEmployee || type
  return result
}

export function resolveBookerType(type) {
  if (type === 'INLAND' || type === 'Nội địa Việt Nam') return 'INLAND'
  if (type === 'INTERNATIONAL' || type === 'Quốc tế') return 'INTERNATIONAL'
  if (type === 'INLAND_AND_INTERNATIONAL' || type === 'Nội địa và Quốc tế') return 'INLAND_AND_INTERNATIONAL'
  return type
}

export const resolveEmployeeTypeVariant = type => {
  if (type === 'ADM') return 'danger'
  if (type === 'OPE') return 'warning'
  if (type === 'KTT') return 'success'
  if (type === 'KTV') return 'success'
  if (type === 'BE') return 'info'
  if (type === 'SE') return 'primary'
  return 'primary'
}

export const statusOptions = computed(() => store.getters['globalConfig/getConfig']('employeeStatus')?.map(item => ({
  value: item.key === 'ACTIVE',
  label: item.value,
  text: item.value,
})))

// [ // same isActive
//   { label: 'Active', text: 'Active', value: true },
//   { label: 'Inactive', text: 'Inactive', value: false },
// ]

// ANCHOR Agency
export const statusAgencyOptions = computed(() => store.getters['globalConfig/getConfig']('agencyStatus')?.map(item => ({
  value: item.key,
  label: item.value,
  text: item.value,
})))
// [
//   { label: 'New', text: 'New', value: 'NEW' },
//   { label: 'inContract', text: 'In Contract', value: 'IN_CONTRACT' },
//   { label: 'Signed', text: 'Signed', value: 'SIGNED' },
//   { label: 'Delivered', text: 'Delivered', value: 'DELIVERED' },
//   { label: 'Done', text: 'Done', value: 'DONE' },
// ]

export function resolveAgencyStatus(status, from = 'label', to = 'value') {
  return statusAgencyOptions.value?.find(
    item => item[from].toLowerCase() === status.toLowerCase(),
  )[to]
}

// ANCHOR Contact
export const typeOfPassengerOptions = computed(() => store.getters['globalConfig/getConfig']('paxType')?.map(item => ({
  value: item.key,
  label: item.value,
  text: item.value,
})))
// [
//   { label: 'Adult', text: 'Adult', value: 'ADULT' },
//   { label: 'Child', text: 'Child', value: 'CHILD' },
//   { label: 'Infant', text: 'Infant', value: 'INFANT' },
// ]

export function resolveTypeOfPassengerOptions(
  type,
  from = 'value',
  to = 'label',
) {
  return typeOfPassengerOptions.value.find(
    item => item[from].toLowerCase() === type.toLowerCase(),
  )[to]
}

// ANCHOR Document
export const typeDocumentOptions = [
  { label: 'eContract', text: 'eContract', value: 'E_CONTRACT' },
  { label: 'NDA', text: 'NDA', value: 'NDA' },
  { label: 'EULA', text: 'EULA', value: 'EULA' },
  {
    label: 'License Agreement',
    text: 'License Agreement',
    value: 'LICENSE_AGREEMENT',
  },
]

export const statusDocumentOptions = [
  { label: 'Active', text: 'Active', value: 'ACTIVE' },
  { label: 'Draft', text: 'Draft', value: 'DRAFT' },
  { label: 'Expired', text: 'Expired', value: 'EXPIRED' },
  { label: 'Cancel', text: 'Cancel', value: 'CANCELLED' },
]

// ANCHOR Topup
export const statusTopupOptions = computed(() => store.getters['globalConfig/getConfig']('topupStatus')
  // ?.filter(item => ['PENDING_PAYMENT', 'DONE'].includes(item.key))
  ?.map(item => ({
    value: item.key,
    label: item.value,
  })))
// [
//   { value: 'PENDING_PAYMENT', label: 'topup.status.pendingPayment' },
//   { value: 'DONE', label: 'topup.status.done' },
//   { value: 'CANCELED', label: 'topup.status.canceled' },
//   { value: 'CONFIRMING', label: 'topup.status.confirming' },
// ]

export function resolveTopupStatus(status, from = 'value', to = 'label') {
  return statusTopupOptions.value?.find(item => item[from] === status)[to]
}

export function resolveTopupStatusVariant(status) {
  // PENDING_PAYMENT
  if (status === 'PENDING_PAYMENT') return 'warning'
  // DONE
  if (status === 'DONE') return 'success'
  // CANCELED
  if (status === 'CANCELED') return 'danger'
  // CONFIRMING
  if (status === 'CONFIRMING') return 'info'
  return ''
}

/*
// ANCHOR Audit Log
export const auditFeaturesOptions = computed(() => store.getters['globalConfig/getConfig']('auditFeatures')?.map(item => ({
  value: item.key,
  label: item.value,
})))
// [
//   { value: 'BOOKING', label: 'auditLog.features.booking' },
//   { value: 'RESERVATION', label: 'auditLog.features.reservation' },
//   { value: 'TICKET', label: 'auditLog.features.ticket' },
//   { value: 'AGENCY', label: 'auditLog.features.agency' },
//   { value: 'CUSTOMER', label: 'auditLog.features.customer' },
//   { value: 'EMPLOYEE', label: 'auditLog.features.employee' },
// ]

export function resolveAuditFeature(option, from = 'value', to = 'label') {
  return auditFeaturesOptions.value?.find(item => item[from] === option)[to]
}
*/

const TITLE_LISTS = {
  MR: 'MR',
  MRS: 'MRS',
  MS: 'MS',
  MISS: 'MISS',
  MASTER: 'MSTR',
  MSTR: 'MSTR',
}

export const resolveTitle = tt => TITLE_LISTS[tt] || ''

export const resolveBookingStatusVariant = type => {
  if (type === 'CANCEL' || type === 'CANCELLED' || type === 'DISAPPEAR') return 'danger'
  if (type === 'EXPIRED') return 'secondary'
  if (type === 'HOLD') return env.isWarningVariantBadgeHoldBooking ? 'warning' : 'info'
  if (type === 'PAID') return 'success'
  if (type === 'PARTIALLY_PAID' || type === 'PARTIALLY_PAID_ONLY') return 'danger'
  if (type === 'ACTIVE') return 'info'
  if (type === 'DRAFT') return 'dark'
  return 'primary'
}

// Chuyển sang dùng fe-config
const SERVICE_NAMES = computed(() => {
  const getFromStore = store.getters['globalConfig/getConfig']('servicesName')
  const result = getFromStore?.reduce((acc, item) => {
    acc[item.key] = {
      vi: item.viValue,
      en: item.value,
    }
    return acc
  }, {})
  return result
})

export const specialServicesListVN1A = [ // FIXME: có code trùng với ssr của các hãng khác, tạm thời k lên fe config
  {
    id: 0, value: '', label: 'wheelchair', isGroup: true,
  },
  { id: 1, value: 'WCHR', label: 'wheelchairService' },
  {
    id: 3, value: '', label: 'assistanceServices', isGroup: true,
  },
  { id: 4, value: 'DEAF', label: 'hearingImpairedPassenger' },
  { id: 5, value: 'BLND', label: 'visuallyImpairedPassenger' },
  {
    id: 7, value: '', label: 'specialMeals', isGroup: true,
  },
  { id: 8, value: 'VJML', label: 'jainVegetarianMeal' },
  {
    id: 9,
    value: 'VGML',
    label: 'strictWesternVegetarianMeal',
  },
  { id: 10, value: 'VLML', label: 'westernVegetarianMeal' },
  { id: 11, value: 'VOML', label: 'orientalVegetarianMeal' },
  {
    id: 12,
    value: 'AVML',
    label: 'hinduVegetarianMeal',
  },
  { id: 13, value: 'HNML', label: 'hinduMeal' },
  { id: 14, value: 'MOML', label: 'muslimMeal' },
  { id: 15, value: 'BBML', label: 'infantMeal2Old' },
  {
    id: 16,
    value: 'CHML',
    label: 'ChildMeal2to5Old',
  },
  { id: 17, value: 'BLML', label: 'blandandSoftMeal' },
  {
    id: 18,
    value: 'DBML',
    label: 'diabeticMeal',
  },
  {
    id: 19,
    value: 'GFML',
    label: 'glutenIntolerantMeal',
  },
  { id: 20, value: 'LCML', label: 'lowCalorieMeal' },
  { id: 21, value: 'LFML', label: 'lowFatMeal' },
  { id: 22, value: 'LSML', label: 'lowSaltMeal' },
  {
    id: 23,
    value: 'NLML',
    label: 'lowLactoseMeal',
  },
  {
    id: 24,
    value: 'FPML',
    label: 'fruitPlatterMeal',
  },
  {
    id: 25,
    value: 'RVML',
    label: 'vegetarianMeal',
  },
  {
    id: 26, value: '', label: '', isGroup: true, // add space
  },
  {
    id: 27, value: '', label: '', isGroup: true, // add space
  },
]

export const resolveSpecialServicesVN1AByCode = code => specialServicesListVN1A.find(it => it.value === code) // maybe undefined

const localeDefault = computed(() => VueI18n.locale ?? 'vi')

export function resolveSsrNameByCode(code, locale = localeDefault.value) {
  const byFeConfig = SERVICE_NAMES.value?.[code]?.[locale]
  const bySpecialServiceVN1A = resolveSpecialServicesVN1AByCode(code)?.label
  return byFeConfig || bySpecialServiceVN1A || code
}

export const resolveSsrBagsName = (srv, locale = localeDefault.value) => {
  if (['VJ', 'VZ', 'VU', 'TR', 'JQ'].includes(srv.airline)) return SERVICE_NAMES.value?.[srv.code]?.[locale] || `Gói ${srv.code}`
  if (!isEmpty(srv.details[0])) {
    return `${VueI18n.t('flight.baggagePackage')} ${srv.details[0].weight} ${srv.details[0].unit}`
  }
  return srv.code
}

export const resolveVariantByBagg = srv => {
  if (['VJ', 'VZ'].includes(srv.airline)) {
    if (srv.code.includes('Cabin Extra 2k') || srv.code.includes('Oversize')) {
      return 'text-danger'
    }
  }
  return 'text-dark'
}

// NOTE: Nhóm 2 của VJ quốc tế gồm:
// - Các đường bay quốc tế giữa Kazakhstan/ Úc và Việt Nam.
// - Các đường bay nối chuyến quốc tế từ/ đến Úc.
export const iataCodeVJ2 = [
  'ALA', 'NQZ', 'BNE', 'MEL', 'SYD',
  'CNS', 'BNK', 'DRW', 'TSV', 'OOL', 'HBA', 'NTL',
  'LST', 'CBR',
]

// https://discord.com/channels/1054696448110903327/1265138644004634685
export const iataCodeVJ3 = ['PER', 'ADL']

// Code sân bay Ấn Độ
// https://discord.com/channels/1054696448110903327/1268867825083093012/1269880682008678443
export const iataCodeIndia = [
  'LTU',
  'ZER',
  'SHL',
  'RUP',
  'VNS',
  'KTU',
  'WGC',
  'GOI',
  'PAB',
  'IXW',
  'HSS',
  'GOI',
  'PNQ',
  'VNS',
  'KUU',
  'GAY',
  'IXU',
  'LKO',
  'RTC',
  'DBD',
  'DAE',
  'MZU',
  'BUP',
  'RPR',
  'BEP',
  'VDY',
  'BLR',
  'CCJ',
  'BDQ',
  'IXI',
  'IXA',
  'IXD',
  'BHU',
  'IXB',
  'CCU',
  'IXZ',
  'IXE',
  'TRV',
  'IXM',
  'NAG',
  'CJB',
  'SAG',
  'PGH',
  'RRK',
  'TIR',
  'BKB',
  'CDP',
  'ISK',
  'VGA',
  'GOP',
  'CBD',
  'IXL',
  'HYD',
  'ATQ',
  'KQH',
  'DGH',
  'JSA',
  'IMF',
  'JDH',
  'LUH',
  'IXS',
  'AGR',
  'IXJ',
  'IXY',
  'DIU',
  'DED',
  'JRG',
  'JRH',
  'GUX',
  'SSE',
  'IXN',
  'TEI',
  'IXK',
  'PBD',
  'DMU',
  'PYB',
  'IXH',
  'BPM',
  'STV',
  'SXV',
  'IXQ',
  'LDA',
  'AJL',
  'NDC',
  'DIB',
  'IXT',
  'JLR',
  'VTZ',
  'SXR',
  'GWL',
  'PAT',
  'IDR',
  'IXC',
  'HJR',
  'COH',
  'IXP',
  'AGX',
  'MYQ',
  'IXV',
  'RGH',
  'TJV',
  'TEZ',
  'IXR',
  'BHJ',
  'BHO',
  'PNY',
  'HBX',
  'KNU',
  'NMB',
  'GAU',
  'KLH',
  'UDR',
  'AKD',
  'JGA',
  'SLV',
  'JAI',
  'TNI',
  'IXG',
  'RJA',
  'RAJ',
  'MAA',
  'BBI',
  'COK',
  'TRZ',
  'DHM',
  'AMD',
  'BOM',
  'DEL',
]

export const skyTeamAirlineGroupOptions = [
  { value: 'AF', text: 'AIR FRANCE (AF)' },
  { value: 'OK', text: 'CZECH AIRLINES (OK)' },
  { value: 'UX', text: 'AIR EUROPA (UX)' },
  { value: 'KE', text: 'KOREAN AIR LINES CO LTD (KE)' },
  { value: 'SU', text: 'AEROFLOT RUSSIAN INTL. A (SU)' },
  { value: 'VN', text: 'VIETNAM AIRLINES CORP (VN)' },
  { value: 'MU', text: 'CHINA EASTERN AIRLINES (MU)' },
  { value: 'CI', text: 'CHINA AIRLINES (CI)' },
  { value: 'ME', text: 'MIDDLE EAST AIRLINES AIR (ME)' },
  { value: 'MF', text: 'XIAMEN AIRLINES (MF)' },
  { value: 'VS', text: 'VIRGIN ATLANTIC (VS)' },
  { value: 'DL', text: 'DELTA AIR LINES (DL)' },
  { value: 'KL', text: 'KLM ROYAL DUTCH AIRL (KL)' },
  { value: 'AM', text: 'AEROMEXICO (AM)' },
  { value: 'AZ', text: 'ITA AIRWAYS (AZ)' },
  { value: 'KQ', text: 'KENYA AIRWAYS (KQ)' },
  { value: 'RO', text: 'TAROM ROMANIAN AIR TRAN (RO)' },
  { value: 'FM', text: 'SHANGHAI AIRLINES CO LT (FM)' },
  { value: 'SV', text: 'SAUDI ARABIAN AIRLINES (SV)' },
  { value: 'AR', text: 'AEROLINEAS ARGENTINAS (AR)' },
  { value: 'GA', text: 'GARUDA INDONESIA (GA)' },
]

export const oneWorldAirlineGroupOptions = [
  { value: 'AA', text: 'AMERICAN AIRLINES (AA)' },
  { value: 'IB', text: 'IBERIA (IB)' },
  { value: 'CX', text: 'CATHAY PACIFIC AIRWAYS L (CX)' },
  { value: 'JL', text: 'JAPAN AIRLINES INTL (JL)' },
  { value: 'MH', text: 'MALAYSIA AIRLINES BERHAD (MH)' },
  { value: 'UL', text: 'SRILANKAN AIRLINES (UL)' },
  { value: 'AS', text: 'ALASKA AIRLINES (AS)' },
  { value: 'BA', text: 'BRITISH AIRWAYS (BA)' },
  { value: 'AY', text: 'FINNAIR (AY)' },
  { value: 'QF', text: 'QANTAS AIRWAYS LIMITED (QF)' },
  { value: 'RJ', text: 'ROYAL JORDANIAN (RJ)' },
  { value: 'QR', text: 'QATAR AIRWAYS (QR)' },
  { value: 'AT', text: 'ROYAL AIR MAROC (AT)' },
]

export const starAllianceAirlineGroupOptions = [
  { value: 'UA', text: 'UNITED AIRLINES INC (UA)' },
  { value: 'AC', text: 'AIR CANADA (AC)' },
  { value: 'TG', text: 'THAI AIRWAYS INTL (TG)' },
  { value: 'NH', text: 'ALL NIPPON AIRWAYS COMPA (NH)' },
  { value: 'SQ', text: 'SINGAPORE AIRLINES (SQ)' },
  { value: 'LO', text: 'LOT POLISH AIRLINES (LO)' },
  { value: 'TP', text: 'TAP AIR PORTUGAL (TP)' },
  { value: 'SA', text: 'SOUTH AFRICAN AIRWAYS (SA)' },
  { value: 'TK', text: 'TURKISH AIRLINES INC (TK)' },
  { value: 'SN', text: 'BRUSSELS AIRLINES (SN)' },
  { value: 'ET', text: 'ETHIOPIAN AIRLINES ENTER (ET)' },
  { value: 'TA', text: 'TACA INTERNATIONAL AIRLI (TA)' },
  { value: 'LR', text: 'AVIANCA COSTA RICA S.A. (LR)' },
  { value: 'BR', text: 'EVA AIRWAYS (BR)' },
  { value: 'AI', text: 'NACIL DBA AIR INDIA (AI)' },
  { value: 'LH', text: 'DEUTSCHE LUFTHANSA AG (LH)' },
  { value: 'SK', text: 'SCANDINAVIAN AIRLINES (SK)' },
  { value: 'NZ', text: 'AIR NEW ZEALAND LIMITED (NZ)' },
  { value: 'OS', text: 'AUSTRIAN AIRLINES (OS)' },
  { value: 'OZ', text: 'ASIANA AIRLINES INC (OZ)' },
  { value: 'OU', text: 'CROATIA AIRLINES (OU)' },
  { value: 'LX', text: 'SWISS (LX)' },
  { value: 'CA', text: 'AIR CHINA LIMITED (CA)' },
  { value: 'MS', text: 'EGYPTAIR (MS)' },
  { value: 'A3', text: 'AEGEAN AIRLINE S.A (A3)' },
  { value: 'AV', text: 'AVIANCA AEROVIAS (AV)' },
  { value: 'T0', text: 'AVIANCA PERU S.A (T0)' },
  { value: 'CM', text: 'COPA AIRLINES (CM)' },
  { value: 'ZH', text: 'SHENZHEN AIRLINES (ZH)' },
]

export const feeTypeOptions = [
  { label: 'perSegmentPerPassenger', value: 'FLIGHT_ITINERARY' },
  { label: 'perSegmentWithStopPerPassenger', value: 'FLIGHT_SEGMENT' },
]

// logic check domestic flight
export const domesticIATACodes = ['HAN', 'SGN', 'DAD', 'PQC', 'CXR', 'CAH', 'VCA', 'VCL', 'VCS', 'DLI', 'DIN', 'VDH', 'HPH', 'HUI', 'PXU', 'UIH', 'VKG', 'THD', 'VII', 'TBB', 'VDO', 'NHA', 'BMV', 'PHA', 'PHH', 'SQH', 'VTG']

export function checkDomesticPoint(point) {
  if (!point) return false
  return domesticIATACodes.includes(point)
}

export function isDomesticFlight(departure, arrival) {
  if (!departure || !arrival) return false
  return checkDomesticPoint(departure) && checkDomesticPoint(arrival)
}

// ANCHOR view config card
export const sortItinerariesTypeOptions = [
  { label: 'CHEAPEST_FARE', value: 'CHEAPEST_FARE' },
  { label: 'EXPENSIVEST_FARE', value: 'EXPENSIVEST_FARE' },
  { label: 'AIRLINE', value: 'AIRLINE' },
  { label: 'EARLIEST_DEPARTURE', value: 'EARLIEST_DEPARTURE' },
  { label: 'LATEST_DEPARTURE', value: 'LATEST_DEPARTURE' },
  { label: 'EARLIEST_ARRIVAL', value: 'EARLIEST_ARRIVAL' },
  { label: 'LATEST_ARRIVAL', value: 'LATEST_ARRIVAL' },
  { label: 'SHORTEST_DURATION', value: 'SHORTEST_DURATION' },
  { label: 'LONGEST_DURATION', value: 'LONGEST_DURATION' },
]

// for show price
export const showPriceOptions = [
  { label: 'TOTAL_FARE', value: 'TOTAL_FARE' },
  { label: 'NET_FARE', value: 'NET_FARE' },
  { label: 'TICKET_FARE', value: 'TICKET_FARE' },
  { label: 'HIDE_FARE', value: 'HIDE_FARE' },
]

export const recipientRefTypeOptions = [
  { label: 'Customer', value: 'CUSTOMER' },
  {
    // label: 'Nhân viên',
    label: 'entireSystem',
    value: 'EMPLOYEE',
  },
  { label: 'company', value: 'COMPANY' },
  { label: 'addAgency', value: 'AGENCY' },
]

export const sendTypeOptions = [
  { label: 'immediately', value: 'INSTANT' },
  { label: 'workSchedule', value: 'SCHEDULE' },
]

export const reschedulePeriodInSecondTypeOptions = Array.from({ length: 24 }, (_, i) => ({
  label: `${i + 1} giờ`,
  value: (i + 1) * 3600,
}))

export const channelOptions = [
  { label: 'Email', value: 'EMAIL' },
  { label: 'title', value: 'PUSH_NOTI' },
]

// ANCHOR dùng cho danh sách ẩn hiện booking filter
export const isActiveOptions = [
  { label: 'Hide', value: false },
  { label: 'Show', value: true },
  { label: 'lockBalance', value: 'lockBalance' },
  { label: 'All', value: null },
]

// ANCHOR dùng cho danh sách thống kê canh vé
export const taskStatusOptions = [
  { label: 'trackingSuccess', value: 'SUCCESS' },
  { label: 'tracking', value: 'PROCESSING' },
  { label: 'trackingNotSuccess', value: 'CANCELLED' },
  { label: 'all', value: null },
]

// Các ngày lễ ở Việt Nam
export const specialDayOfVietnam = [
  // Dương lịch
  { date: 1, month: 1, type: 'solar' },
  { date: 30, month: 4, type: 'solar' },
  { date: 1, month: 5, type: 'solar' },
  { date: 2, month: 9, type: 'solar' },
  { date: 24, month: 12, type: 'solar' },
  { date: 25, month: 12, type: 'solar' },
  // Âm lịch
  { date: 1, month: 1, type: 'lunar' },
  { date: 2, month: 1, type: 'lunar' },
  { date: 3, month: 1, type: 'lunar' },
  { date: 10, month: 3, type: 'lunar' },
  { date: 30, month: 12, type: 'lunar' },
]

const insuranceSpecialServicesName = {
  PAID: 'Đã thanh toán',
  CANCEL: 'Đã huỷ',
  PENDING_SUBMISSION: 'Chờ xác nhận',
  PENDING_PAYMENT: 'Chưa thanh toán',
  REFUND: 'Đã hoàn',
}

export const resolveInsuranceSpecialServicesName = val => insuranceSpecialServicesName[val] || val

export const resolveVariantInsuranceServices = val => {
  if (val === 'PAID') return 'success'
  if (val === 'CANCEL') return 'danger'
  if (val === 'PENDING_SUBMISSION') return 'secondary'
  if (val === 'PENDING_PAYMENT') return 'info'
  return 'warning'
}

// updates: 09/03/24: https://discord.com/channels/1054696448110903327/1055496658684743721/1215711321937551430

// class filter
export const cabinPreferenceOptions = [
  { label: 'ECONOMY', value: 'ECONOMY' }, // Phổ thông
  { label: 'PREMIUM_ECONOMY', value: 'PREMIUM_ECONOMY' }, // Phổ thông đặc biệt
  { label: 'BUSINESS', value: 'BUSINESS' }, // Thương gia
  { label: 'FIRST', value: 'FIRST' }, // Hạng nhất
]

// preference type filter
export const preferenceTypeOptions = [
  { label: 'PERMITTED', value: 'PERMITTED' }, // filter đúng loại cabin đã chọn
  { label: 'PREFERRED', value: 'PREFERRED' }, // filter theo cabin đã chọn, nếu ko có cabin đã chọn sẽ trả về cabin hạng thấp hơn
  { label: 'PREFERRED_WITH_UPGRADE', value: 'PREFERRED_WITH_UPGRADE' }, // filter theo cabin đã chọn, nếu ko có cabin đã chọn sẽ trả về cabin hạng cao hơn
]

const FN_MODIFY_ANCILLARY_BY_SOURCE = {
  '1G': {
    PAY_LATE: false, // Thanh toán ngay / thanh toán sau
    BAGGAGE: { // Hành lý mua thêm
      available: false, // Có API mua thêm hành lý với source
      add: false, // có API Thêm hành lý
      edit: false, // API Sửa gói
      delete: false, // API Xoá gói
      multiple: false, // có thể thêm, mua nhiều gói
      increase: false, // tăng số lượng
      decrease: false, // giảm số lượng
      maximumQuantity: 0, // tối đa số lượng tổng gói
      maximumQuantityOnEach: 0, //  tối đa số lượng của từng gói
    },
    OTHER: {
      available: false,
      add: false,
      edit: false,
      delete: false,
      multiple: false,
      maximumQuantity: 0,
      maximumQuantityOnEach: 0,
    },
    SEAT: {
      available: false,
      add: false,
      edit: false,
      delete: false,
    },
  },
  F1: {
    PAY_LATE: true,
    BAGGAGE: {
      available: false,
      add: true,
      edit: true,
      delete: true,
      multiple: true,
      increase: true,
      decrease: true,
      maximumQuantity: 0,
      maximumQuantityOnEach: 0,
    },
    OTHER: {
      available: false,
      add: true,
      edit: true,
      delete: true,
      multiple: true,
      maximumQuantity: 0,
      maximumQuantityOnEach: 0,
    },
    SEAT: {
      available: false,
      add: false,
      edit: false,
      delete: false,
    },
  },
  AK: {
    PAY_LATE: false,
    BAGGAGE: {
      available: true,
      add: true,
      edit: false,
      delete: false,
      multiple: true,
      increase: false,
      decrease: false,
      maximumQuantity: 999,
      maximumQuantityOnEach: 1,
    },
    OTHER: {
      available: true,
      add: true,
      edit: false,
      delete: false,
      multiple: true,
      maximumQuantity: 999,
      maximumQuantityOnEach: 1,
    },
    SEAT: {
      available: true,
      add: true,
      edit: false,
      delete: false,
    },
  },
  TH: {
    PAY_LATE: true,
    BAGGAGE: {
      available: true,
      add: false,
      edit: false,
      delete: false,
      multiple: false,
      increase: false,
      decrease: false,
      maximumQuantity: 0,
      maximumQuantityOnEach: 0,
      isSegment: true, // Mua hành lý theo chặng hay ko ?
    },
    OTHER: {
      available: true,
      add: false,
      edit: false,
      delete: false,
      multiple: false,
      maximumQuantity: 0,
      maximumQuantityOnEach: 0,
    },
    SEAT: {
      available: false,
      add: false,
      edit: false,
      delete: false,
    },
  },
  TR: {
    PAY_LATE: true,
    BAGGAGE: {
      available: true,
      add: true,
      edit: false,
      delete: false,
      multiple: false,
      increase: false,
      decrease: false,
      maximumQuantity: 0,
      maximumQuantityOnEach: 1,
      isSegment: true, // Mua theo chặng hay ko? => mặc định theo segment, nếu là chặng ẩn sẽ là 2 chặng gộp lại.
    },
    OTHER: {
      available: true,
      add: true,
      edit: false,
      delete: false,
      multiple: false,
      maximumQuantity: 999,
      maximumQuantityOnEach: 1,
      isSegment: true, // Mua theo chặng hay ko? => mặc định theo segment, nếu là chặng ẩn sẽ là 2 chặng gộp lại.
    },
    SEAT: {
      available: true,
      add: true,
      edit: false,
      delete: false,
      isSegment: true, // Mua theo chặng hay ko? => mặc định theo segment, nếu là chặng ẩn sẽ là 2 chặng gộp lại.
    },
  },
  JQ: {
    PAY_LATE: true,
    BAGGAGE: {
      available: true,
      add: true,
      edit: false,
      delete: false,
      multiple: false,
      increase: false,
      decrease: false,
      maximumQuantity: 0,
      maximumQuantityOnEach: 1,
      isSegment: false, // Mua theo chặng hay ko? => mặc định theo segment, nếu là chặng ẩn sẽ là 2 chặng gộp lại.
      maximumWeight: 40,
    },
    OTHER: {
      available: true,
      add: true,
      edit: false,
      delete: false,
      multiple: false,
      maximumQuantity: 999,
      maximumQuantityOnEach: 1,
      isSegment: true, // Mua theo chặng hay ko? => mặc định theo segment, nếu là chặng ẩn sẽ là 2 chặng gộp lại.
    },
    SEAT: {
      available: true,
      add: true,
      edit: false,
      delete: false,
      isSegment: true, // Mua theo chặng hay ko? => mặc định theo segment, nếu là chặng ẩn sẽ là 2 chặng gộp lại.
    },
  },
  VN1A: {
    PAY_LATE: true,
    BAGGAGE: {
      available: true,
      add: true,
      edit: false,
      delete: false, // xoá theo status của booking
      multiple: false,
      increase: true,
      decrease: true,
      maximumQuantity: 15,
      maximumQuantityOnEach: 15,
    },
    OTHER: {
      available: true,
      add: true,
      edit: false,
      delete: false, // xoá theo status của booking
      multiple: false,
      maximumQuantity: 1,
      maximumQuantityOnEach: 1,
    },
    SEAT: {
      available: true,
      add: true,
      edit: false,
      delete: false, // xoá theo status của booking
    },
  },
  QH: {
    PAY_LATE: false,
    BAGGAGE: {
      available: true,
      add: true,
      edit: false,
      delete: false,
      multiple: true,
      increase: true,
      decrease: true,
      maximumQuantity: 999,
      maximumQuantityOnEach: 999,
      maximumWeight: 60, // Kgs
    },
    OTHER: {
      available: true,
      add: true,
      edit: false,
      delete: false,
      multiple: true,
      maximumQuantity: 999,
      maximumQuantityOnEach: 1,
    },
    SEAT: {
      available: true,
      add: true,
      edit: false,
      delete: false,
    },
  },
  VJ: {
    // NOTE: gói hành lý thêm 2kg của VJ sẽ thêm riêng
    PAY_LATE: true,
    BAGGAGE: {
      available: true,
      add: true,
      edit: true,
      delete: true,
      multiple: true,
      increase: false,
      decrease: false,
      maximumQuantity: 2, // VJ mua được gói 2kg và 1 gói khác
      maximumQuantityOnEach: 1,
    },
    OTHER: {
      available: true,
      add: true,
      edit: false,
      delete: true,
      multiple: true,
      maximumQuantity: 999, // VJ: nhiều gói, nhiều số lượng
      maximumQuantityOnEach: 1,
    },
    SEAT: {
      available: true,
      add: true,
      edit: false,
      delete: false,
    },
  },
  VU: {
    PAY_LATE: false,
    BAGGAGE: {
      available: true,
      add: true,
      edit: false, // không khả dụng trên hành trình đã mua
      delete: false,
      multiple: true,
      increase: false,
      decrease: false,
      maximumQuantity: 999, // VU có thể thêm nhiều gói hành lý mỗi loại khác nhau
      maximumQuantityOnEach: 1,
    },
    OTHER: {
      available: true,
      add: true,
      edit: false,
      delete: false,
      multiple: true,
      maximumQuantity: 999,
      maximumQuantityOnEach: 1,
    },
    SEAT: {
      available: true,
      add: true,
      edit: false,
      delete: false,
    },
  },
  404: {
    PAY_LATE: false,
    BAGGAGE: {
      available: false,
      add: false,
      edit: false,
      delete: false,
      multiple: false,
      increase: false,
      decrease: false,
      maximumQuantity: 0,
      maximumQuantityOnEach: 0,
    },
    OTHER: {
      available: false,
      add: false,
      edit: false,
      delete: false,
      multiple: false,
      maximumQuantity: 0,
      maximumQuantityOnEach: 0,
    },
    SEAT: {
      available: false,
      add: false,
      edit: false,
      delete: false,
    },
  },
}

/*
============ v1.2 ===============
QH: {
  PAY_LATE: ['VJ', 'TH', 'F1],
  PAY_NOW: ['QH', 'AK'],
  BAGGAGE: {
    available: ['VJ', 'TH', 'F1'],
    add: ['VJ', 'TH', 'F1', 'QH'],
    edit: ['VJ', 'TH', 'F1', 'QH'],
    delete: ['VJ', 'TH', 'F1', 'QH'],
    multiple: ['VJ', 'TH', 'F1', 'QH'],
    increase: ['VJ', 'TH', 'F1', 'QH'],
    decrease: ['VJ', 'TH', 'F1', 'QH'],
    maximumQuantity: [
    {
      source: VJ,
      value: 2
    },
    {
      source: QH,
      value: 999
    }
    ],
    maximumQuantityOnEach: [
    {
      source: VJ,
      value: 1
    },
    {
      source: QH,
      value: 1
    },
    ],
    maximumWeight: [
    {
      source: VJ,
      value: 999
    },
    {
      source: QH,
      value: 60
    },
    ], // Kgs
  },
  OTHER: {
    available: ['QH', 'AK'],
    add: ['QH', 'AK'],
    edit: ['QH', 'AK'],
    delete: ['QH', 'AK'],
    multiple: ['QH', 'AK'],
    maximumQuantity: 999,
    maximumQuantityOnEach: 1,
  },
  SEAT: {
    available: ['QH', 'AK', 'VJ'],
    add: ['QH', 'AK'],
    edit: ['QH', 'AK'],
    delete: ['QH', 'AK'],
  },
}
 ===============================
 */

const getBookingModifyRealSource = val => {
  if (['VN1A', 'VN1A_MT'].includes(val)) return 'VN1A'
  return val
}
export const resolveFnModifyAddonsBySource = source => {
  const realSource = getBookingModifyRealSource(source)
  return FN_MODIFY_ANCILLARY_BY_SOURCE[realSource] || FN_MODIFY_ANCILLARY_BY_SOURCE[404]
}

export const currencyOptions = [
  'VND',
  'USD',
  'EUR',
  'GBP',
  'CAD',
  'AED',
  'AFN',
  'ALL',
  'AMD',
  'ARS',
  'AUD',
  'AZN',
  'BAM',
  'BDT',
  'BGN',
  'BHD',
  'BIF',
  'BND',
  'BOB',
  'BRL',
  'BWP',
  'BYN',
  'BZD',
  'CDF',
  'CHF',
  'CLP',
  'CNY',
  'COP',
  'CRC',
  'CVE',
  'CZK',
  'DJF',
  'DKK',
  'DOP',
  'DZD',
  'EEK',
  'EGP',
  'ERN',
  'ETB',
  'GEL',
  'GHS',
  'GNF',
  'GTQ',
  'HKD',
  'HNL',
  'HRK',
  'HUF',
  'IDR',
  'ILS',
  'INR',
  'IQD',
  'IRR',
  'ISK',
  'JMD',
  'JOD',
  'JPY',
  'KES',
  'KHR',
  'KMF',
  'KRW',
  'KWD',
  'KZT',
  'LBP',
  'LKR',
  'LTL',
  'LVL',
  'LYD',
  'MAD',
  'MDL',
  'MGA',
  'MKD',
  'MMK',
  'MOP',
  'MUR',
  'MXN',
  'MYR',
  'MZN',
  'NAD',
  'NGN',
  'NIO',
  'NOK',
  'NPR',
  'NZD',
  'OMR',
  'PAB',
  'PEN',
  'PHP',
  'PKR',
  'PLN',
  'PYG',
  'QAR',
  'RON',
  'RSD',
  'RUB',
  'RWF',
  'SAR',
  'SDG',
  'SEK',
  'SGD',
  'SOS',
  'SYP',
  'THB',
  'TND',
  'TOP',
  'TRY',
  'TTD',
  'TWD',
  'TZS',
  'UAH',
  'UGX',
  'UYU',
  'UZS',
  'VEF',
  'XAF',
  'XOF',
  'YER',
  'ZAR',
  'ZMK',
  'ZWL',
]
